/** @jsxImportSource @emotion/react */
import { UserMemberCardResponseData } from "../../../../service/api-response/UsersMemberCardsSuccessResponse";
import { css } from "@emotion/react";
import { StyledText } from "../../../../assets/typography/typography";
import { colors } from "../../../../components/colors";
import { CircleContainer } from "../../../../components/CircleContainer";

type Props = {
  membercard: UserMemberCardResponseData;
};

const cardWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const infoStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: start;
`;

const subInfoStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const returnStateColor = (isActive: boolean) => {
  if (!isActive) {
    return colors.errorMedium;
  }
  return colors.successMedium;
};

export const UserMembercardsHeader = ({ membercard }: Props) => {
  return (
    <div css={cardWrapperStyle}>
      <div css={infoStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {membercard.cardType}
        </StyledText>
        <div css={subInfoStyle}>
          <CircleContainer
            height="4px"
            width="4px"
            backgroundColor={returnStateColor(membercard.isActive)}
          />
          <StyledText
            color={colors.textPrimary}
            className="bodySubtextRegular mb-0"
          >
            {membercard.isActive ? "Active" : "Inactive"}
          </StyledText>
        </div>
      </div>
    </div>
  );
};
